/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Ampli - A strong typed wrapper for your Analytics
 *
 * This file is generated by Amplitude.
 * To update run 'ampli pull web-public'
 *
 * Required dependencies: @amplitude/analytics-browser@^1.3.0
 * Tracking Plan Version: 257
 * Build: 1.0.0
 * Runtime: browser:typescript-ampli-v2
 *
 * [View Tracking Plan](https://data.amplitude.com/asktia/Asktia/events/main/latest)
 *
 * [Full Setup Instructions](https://data.amplitude.com/asktia/Asktia/implementation/web-public)
 */

import * as amplitude from '@amplitude/analytics-browser';

export type Environment = 'production' | 'development';

export const ApiKey: Record<Environment, string> = {
  production: 'd2c588dc1f8a91987d7540e4521eef21',
  development: '9018a17347d3e4c10774fd74f8eaef99'
};

/**
 * Default Amplitude configuration options. Contains tracking plan information.
 */
export const DefaultConfiguration: BrowserOptions = {
  plan: {
    version: '257',
    branch: 'main',
    source: 'web-public',
    versionId: 'bb6a8d6e-bf7c-4b95-8f27-acbefc89d61c'
  },
  ...{
    ingestionMetadata: {
      sourceName: 'browser-typescript-ampli',
      sourceVersion: '2.0.0'
    }
  }
};

export interface LoadOptionsBase { disabled?: boolean }

export type LoadOptionsWithEnvironment = LoadOptionsBase & { environment: Environment; client?: { configuration?: BrowserOptions; }; };
export type LoadOptionsWithApiKey = LoadOptionsBase & { client: { apiKey: string; configuration?: BrowserOptions; } };
export type LoadOptionsWithClientInstance = LoadOptionsBase & { client: { instance: BrowserClient; } };

export type LoadOptions = LoadOptionsWithEnvironment | LoadOptionsWithApiKey | LoadOptionsWithClientInstance;

export interface IdentifyProperties {
  "[Experiment] tiara-personal-wellness"?: any;
  /**
   * The date where a member's annual commitment is complete
   */
  annualCommitmentDate?: string;
  /**
   * Tells us the total appointments completed by the user
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  appointment_volume?: number;
  /**
   * Contains the last 4 digits of the latest card on file for a member. This is updated whenever a member updates their card on file
   */
  cardLast4?: string;
  /**
   * When users become members, depending on the terms of their membership plan, they are committed to keep paying until a specified date. If this field is defined, it indicates until when the user has agreed to be billed by TIA.
   */
  commitmentDate?: any;
  currentClinicLocation?: string;
  dashboard_group?: string;
  /**
   * Date of Birth of the user in format YYYY-MM-DD
   */
  dateOfBirth?: string;
  /**
   * Stores the remaining deductible amount of the patient's insurance plan whenever we receive this as part of the eligibility response.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  deductibleRemaining?: number;
  /**
   * Email
   */
  email?: string;
  /**
   * Date of when user created their account.
   */
  emailCreationDate?: string;
  /**
   * UUID/GUID
   */
  externalId?: string;
  /**
   * Tells us the first IRL clinic the user visited
   */
  first_irl_clinic?: string;
  /**
   * First Name
   */
  first_name?: string;
  /**
   * Name of current clinic location. This is the same as 'originatingClinicLocation' unless updated in Settings or elsewhere in the experience.
   */
  homeLocation?: string;
  /**
   * Member home market name
   *
   * | Rule | Value |
   * |---|---|
   * | Min Length | 1 |
   */
  homeMarket?: string;
  /**
   * Member home market Id as defined in Ehr.Market
   *
   * | Rule | Value |
   * |---|---|
   * | Min Length | 1 |
   */
  homeMarketId?: string;
  initial_referrer?: string;
  initial_referring_domain?: string;
  initial_utm_campaign?: string;
  initial_utm_content?: string;
  initial_utm_id?: string;
  initial_utm_medium?: string;
  initial_utm_source?: string;
  initial_utm_term?: string;
  insuranceEligibilityStatus?: string;
  insuranceNetworkStatus?: string;
  /**
   * Whether or not the user has insurance on file.
   */
  insuranceOnFile?: boolean;
  /**
   * The insurance status of the user, whether it is 'eligible' | 'ineligible' | 'unsure'.
   */
  insuranceStatus?: string;
  /**
   * Tells us the most recent IRL clinic the user visited
   */
  last_irl_clinic?: string;
  /**
   * Last Name
   */
  last_name?: string;
  /**
   * last time meber completed annual preventative exam
   */
  lastCompletedAnnualPreventativeExam?: string;
  /**
   * last time someone completed whole health exam in clinic
   */
  lastCompletedTiaWholeHealthInClinicCare?: string;
  mailingAddressCity?: string;
  mailingAddressLine1?: string;
  mailingAddressLine2?: string;
  mailingAddressPostalCode?: string;
  mailingAddressState?: string;
  marketing_consent?: string;
  /**
   * Tells us the date the user's membership was deactivated
   */
  member_end_date?: string;
  /**
   * Indicates the current status of the membership, either active, frozen, cancelled or (none). None indicates either an internal user or a Tia user that didn't convert into a member.
   */
  membership?: string;
  /**
   * Date member originally signed up for their Tia account.
   */
  memberSignUpDate?: string;
  /**
   * Tells us the date of the user's next schedule annual (tia_whole_health_in_clinic_care)
   */
  next_scheduled_tia_whole_health_in_clinic_care?: string;
  /**
   * Captures the user's next membership payment date
   */
  nextPaymentDate?: string;
  /**
   * Location where user originally signed up.
   */
  originatingClinicLocation?: string;
  /**
   * Tracks the user's latest payment method brand
   */
  paymentMethodBrand?: string;
  /**
   * Phone Number
   */
  phone?: string;
  /**
   * What pricing model the user is under currently. In most instances the property will be monthly or annual. But in some of the old members they could have a pricingModel of 1 and 2.
   *
   * * 1: monthly
   *
   * * 2: annual
   */
  pricingModel?: string;
  /**
   * The promo code that was used during registration.
   */
  promoCodeUsed?: string;
  /**
   * The referral code the user used initially during sign up, if available.
   */
  referralCode?: string;
  /**
   * The last page the user was on (for example, https://amplitude.com/behavioral-analytics-platform?ref=nav)
   */
  referrer?: string;
  /**
   * The domain that the user was last on (for example, https://amplitude.com)
   */
  referring_domain?: string;
  /**
   * The date the membership is due for renewal
   */
  renewalTimestamp?: any;
  show_appointments_page_group?: string;
  /**
   * The name of the tier the user belongs to
   *
   * | Rule | Value |
   * |---|---|
   * | Min Length | 1 |
   */
  tier?: string;
  twhe_1_goals_group?: string;
  twhe_onboarding_group?: string;
  userFromWebinar?: boolean;
  /**
   * If this property is set, it means this user was created because they took part of a CDP event, like zoom, intercom, braze, etc.
   */
  userOriginatedFrom?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  userRoles?: string[];
  usingMemberService?: boolean;
  /**
   * This identifies a specific campaign used (for example, "summer_sale")
   */
  utm_campaign?: string;
  /**
   * This identifies what brought the user to the site and is commonly used for A/B testing (for example, "banner-link", "text-link")
   */
  utm_content?: string;
  utm_id?: string;
  utm_medium?: string;
  /**
   * This identifies which website sent the traffic (for example, Google, Facebook)
   */
  utm_source?: string;
  /**
   * This identifies paid search terms used (for example, product+analytics)
   */
  utm_term?: string;
  /**
   * The UTM Campaign Code.
   */
  utmCampaign?: string;
  /**
   * The UTM Source code.
   */
  utmSource?: string;
}

export interface EmailCapturedProperties {
  /**
   * User agrees to receive emails and SMS from Tia
   */
  consent_checked: boolean;
  /**
   * Set the email as the user identifier, we will call an alias call when they verify on the website later and merge with the email.
   */
  email?: string;
  /**
   * Where the email was captured, email newsletter, stress quiz, etc.
   *
   * Examples:
   * Profile, Sign Up
   */
  location?: string;
  /**
   * Captures the phone number that the user used to sign up. This is also set as a user property
   */
  phone?: string;
}

export interface EventRsvpProperties {
  /**
   * The event URL that is passed. ex. eventbrite.com...
   */
  eventUrl?: string;
}

export interface SameDayAppointmentWarningProperties {
  dateOfService: string;
  /**
   * **Captures the outcome of attempting to send the encounter to Candid**
   */
  outcome: string;
  /**
   * The unique identifier for a patient.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  patientId: number;
  serviceTypeLabelOne: string;
  serviceTypeLabelTwo: string;
}

export interface TypeformSubmittedProperties {
  typeformId: string;
}

export interface WebsiteCtaClickedProperties {
  ctaText: string;
  heading: string;
  module: string;
  pagePath: string;
  targetUrl?: string;
}

export class Identify implements BaseEvent {
  event_type = amplitude.Types.SpecialEventType.IDENTIFY;

  constructor(
    public event_properties?: IdentifyProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class EmailCaptured implements BaseEvent {
  event_type = 'Email Captured';

  constructor(
    public event_properties: EmailCapturedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class EventRsvp implements BaseEvent {
  event_type = 'Event Rsvp';

  constructor(
    public event_properties?: EventRsvpProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class JoinNowButtonClicked implements BaseEvent {
  event_type = 'Join Now Button Clicked';
}

export class JoinNowHeroButtonClicked implements BaseEvent {
  event_type = 'Join Now Hero Button Clicked';
}

export class SameDayAppointmentWarning implements BaseEvent {
  event_type = 'Same-day Appointment Warning';

  constructor(
    public event_properties: SameDayAppointmentWarningProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class TypeformSubmitted implements BaseEvent {
  event_type = 'Typeform Submitted';

  constructor(
    public event_properties: TypeformSubmittedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class WebsiteCtaClicked implements BaseEvent {
  event_type = 'Website CTA Clicked';

  constructor(
    public event_properties: WebsiteCtaClickedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export type PromiseResult<T> = { promise: Promise<T | void> };

const getVoidPromiseResult = () => ({ promise: Promise.resolve() });

// prettier-ignore
export class Ampli {
  private disabled: boolean = false;
  private amplitude?: BrowserClient;

  get client(): BrowserClient {
    this.isInitializedAndEnabled();
    return this.amplitude!;
  }

  get isLoaded(): boolean {
    return this.amplitude != null;
  }

  private isInitializedAndEnabled(): boolean {
    if (!this.amplitude) {
      console.error('ERROR: Ampli is not yet initialized. Have you called ampli.load() on app start?');
      return false;
    }
    return !this.disabled;
  }

  /**
   * Initialize the Ampli SDK. Call once when your application starts.
   *
   * @param options Configuration options to initialize the Ampli SDK with.
   */
  load(options: LoadOptions): PromiseResult<void> {
    this.disabled = options.disabled ?? false;

    if (this.amplitude) {
      console.warn('WARNING: Ampli is already intialized. Ampli.load() should be called once at application startup.');
      return getVoidPromiseResult();
    }

    let apiKey: string | null = null;
    if (options.client && 'apiKey' in options.client) {
      apiKey = options.client.apiKey;
    } else if ('environment' in options) {
      apiKey = ApiKey[options.environment];
    }

    if (options.client && 'instance' in options.client) {
      this.amplitude = options.client.instance;
    } else if (apiKey) {
      this.amplitude = amplitude.createInstance();
      const configuration = (options.client && 'configuration' in options.client) ? options.client.configuration : {};
      return this.amplitude.init(apiKey, undefined, { ...DefaultConfiguration, ...configuration });
    } else {
      console.error("ERROR: ampli.load() requires 'environment', 'client.apiKey', or 'client.instance'");
    }

    return getVoidPromiseResult();
  }

  /**
   * Identify a user and set user properties.
   *
   * @param userId The user's id.
   * @param properties The user properties.
   * @param options Optional event options.
   */
  identify(
    userId: string | undefined,
    properties?: IdentifyProperties,
    options?: EventOptions,
  ): PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    if (userId) {
      options = {...options,  user_id: userId};
    }

    const amplitudeIdentify = new amplitude.Identify();
    const eventProperties = properties;
    if (eventProperties != null) {
      for (const [key, value] of Object.entries(eventProperties)) {
        amplitudeIdentify.set(key, value);
      }
    }
    return this.amplitude!.identify(
      amplitudeIdentify,
      options,
    );
  }

 /**
  * Flush the event.
  */
  flush() : PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    return this.amplitude!.flush();
  }

  /**
   * Track event
   *
   * @param event The event to track.
   * @param options Optional event options.
   */
  track(event: Event, options?: EventOptions): PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    return this.amplitude!.track(event, undefined, options);
  }

  /**
   * Email Captured
   *
   * [View in Tracking Plan](https://data.amplitude.com/asktia/Asktia/events/main/latest/Email%20Captured)
   *
   * When email is captured, but a user is not signed up. This event can be used for landing pages like the Stress Quiz to set the user email with a UUID being set.
   *
   *
   * In the Membership Signup: [Github Link](https://github.com/AskTia/www/blob/0cb2be0c32e5b3a70fe6412c4449815080b9636a/controllers/account-controller.js#L137)
   *
   * In Stress Quiz: (Eric doesn't know where this lives)
   *
   * Owner: david+tia@notablegrowth.com
   *
   * @param properties The event's properties (e.g. consent_checked)
   * @param options Amplitude event options.
   */
  emailCaptured(
    properties: EmailCapturedProperties,
    options?: EventOptions,
  ) {
    return this.track(new EmailCaptured(properties), options);
  }

  /**
   * Event Rsvp
   *
   * [View in Tracking Plan](https://data.amplitude.com/asktia/Asktia/events/main/latest/Event%20Rsvp)
   *
   * When a user RSVP for an event on the events page
   *
   * Owner: joelle+tia@notablegrowth.com
   *
   * @param properties The event's properties (e.g. eventUrl)
   * @param options Amplitude event options.
   */
  eventRsvp(
    properties?: EventRsvpProperties,
    options?: EventOptions,
  ) {
    return this.track(new EventRsvp(properties), options);
  }

  /**
   * Join Now Button Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/asktia/Asktia/events/main/latest/Join%20Now%20Button%20Clicked)
   *
   * When the user clicks the Join Now button *in the global nav bar* of asktia.com begin the sign up process. This event does not fire for other Join Now buttons on the marketing site
   *
   *
   *
   *
   * Owner: joelle+tia@notablegrowth.com
   *
   * @param options Amplitude event options.
   */
  joinNowButtonClicked(
    options?: EventOptions,
  ) {
    return this.track(new JoinNowButtonClicked(), options);
  }

  /**
   * Join Now Hero Button Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/asktia/Asktia/events/main/latest/Join%20Now%20Hero%20Button%20Clicked)
   *
   * This event tracks when a user clicks on the "Join Now" button in the hero section of the marketing site
   *
   * @param options Amplitude event options.
   */
  joinNowHeroButtonClicked(
    options?: EventOptions,
  ) {
    return this.track(new JoinNowHeroButtonClicked(), options);
  }

  /**
   * Same-day Appointment Warning
   *
   * [View in Tracking Plan](https://data.amplitude.com/asktia/Asktia/events/main/latest/Same-day%20Appointment%20Warning)
   *
   * Many payers do not cover two medical visits on the same date of service. When a second same-day visit is booked, it often results in a denial, which leads to a poor patient experience. Currently, the clinic ops spends a significant amount of time manually scrubbing schedules to resolve two same-day med visits. To reduce avoidable denials and set expectations, we want to warn patients before confirming a second same-day medical appointment that it may not be covered and they may have to pay out-of-pocket.
   *
   *
   * ![](https://com-amplitude-orbit-media-prod.s3.us-west-2.amazonaws.com/138242/5454ef52-5091-44c4-bb19-5abcb6f75b56.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAVGZURZG7RTN6B5E5%2F20251017%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Date=20251017T173126Z&X-Amz-Expires=3600&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEAEaCXVzLXdlc3QtMiJGMEQCIGCnxyShz9FrrmEdDD%2FtJnAL7nOMAQxtR2lZwWEhox9lAiBTHw3tiCfUJ9gJ76eIIb%2Bng%2BtS2yrIMt3VnwL%2BqBeg7yq8BQiq%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAAaDDM1ODIwMzExNTk2NyIMUKfLNX6iI3RVlTyjKpAF9p9uq8qnnmOMUZ%2FSJmQ9daNSYxk95IjpzXURm2RiDd482Af8ZqyohhU1OwE7Rmoaudl984EbMZwUzfCOzfgQKceHYiLZXFjBL0aPE1bCABiC%2Fj9fpW%2FbCAzCS0y3UpX1zia1jjW1VjfffRHvKmc75I2YWByJSEKJ9vhEa17mxBtSQn6M3HfKgqHn8UbmAOyeRGRk5FNUPJVKmQjQ0hSc2Uo5fM1BvBp71YVeEFXbEbzK87i3zNJAu9pev%2B9UW896zwfVcgY%2BtzpIcLvmKX5n2dXW189wyY600yHKWoYbvo4FeFJK4sI2qgRzzG1O0SBYlzeDG5ZmO3lIl9MzW80N7GIV7yCSrqjoc6BNNqMjAknZqRFbNl0z2OHYR68OcCyRQH3kdXa4aZvZjnSwhp5Y3CF3XDbfjpNvvsVN5PemagsDAmsP1f3wj1dz0tY9LrAbxu1tnIzFuGa1px0uA678J1XFto8%2B%2BttbOkm0yY20ERcvOv%2B4l8%2Ft5rRATVP%2FBRwgVj0Yn6cKPz9O84%2BycDvhIUfMxJfC%2B4rYuvT9bg4KM6Jf%2BSXIQkgDjzNlrmVCMSP7jlhFNXmTzHDui9tWRXE0axeSLrFLXuPy7xakocRbvhmQwC5JdFCj7c2gedZsBqGtmDF0E5hDMd0peMEzRw0fplliRs9nWLG6mM%2FhXBy%2BOeiiInpD7EVVIBeY1FrAa%2B9KKa9tfc274BxoO8tywIldofR%2Buz2GKn4iz1TtkYLlFR4Fi37amPwuOA5PC%2BC3aqUXkYFlhhcTKv6ctZyrxzpRDfcubFSMNkKmVTktfJV8cky0p%2B4ErUa9TR3nf3wCYcEVlNyeGLOcGkdPlrt6cVMomTi7TEBH0070YwWmg737Q5cw1vDJxwY6sgFsVte5Z6PWCya%2BxYzzG4bFsVfjZaJU4mVaGhMWWjtxflWADRHbWuvff9Sich9niYWfE5FEfVZoA0d%2Bqcl9mE73W2fZ7%2BabntWd5KDUv9BcA8weO1gTTsSND1BdLQaX%2BXAey27%2FVTRLApXCDiCHOCniKv%2FTtXiaEtNWW4Nsv0vncm3tk6rqbzalRFFUObVwgcrEzBQ7D2eTWgjhjlo0Y2NDhCGv86mOkWGEs1IcNElP9%2Bua&X-Amz-Signature=8e152f07287585b9217c21a587bf0431df1d4c61433990a9e5b2a597b3a6d7cc&X-Amz-SignedHeaders=host&x-id=GetObject)
   *
   * @param properties The event's properties (e.g. dateOfService)
   * @param options Amplitude event options.
   */
  sameDayAppointmentWarning(
    properties: SameDayAppointmentWarningProperties,
    options?: EventOptions,
  ) {
    return this.track(new SameDayAppointmentWarning(properties), options);
  }

  /**
   * Typeform Submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/asktia/Asktia/events/main/latest/Typeform%20Submitted)
   *
   * Triggered when a typeform on the marketing site is submitted.
   *
   * @param properties The event's properties (e.g. typeformId)
   * @param options Amplitude event options.
   */
  typeformSubmitted(
    properties: TypeformSubmittedProperties,
    options?: EventOptions,
  ) {
    return this.track(new TypeformSubmitted(properties), options);
  }

  /**
   * Website CTA Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/asktia/Asktia/events/main/latest/Website%20CTA%20Clicked)
   *
   * This event records when a user clicks on a Call-To-Action (CTA) button or link on the website. It is triggered immediately upon the user's interaction with any designated CTA element, capturing engagement intent for analysis. The properties help us understand what CTAs are performing better and refine those results with A/B testing, helping us driving more engagement.
   *
   * @param properties The event's properties (e.g. ctaText)
   * @param options Amplitude event options.
   */
  websiteCtaClicked(
    properties: WebsiteCtaClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new WebsiteCtaClicked(properties), options);
  }
}

export const ampli = new Ampli();

// BASE TYPES
type BrowserOptions = amplitude.Types.BrowserOptions;

export type BrowserClient = amplitude.Types.BrowserClient;
export type BaseEvent = amplitude.Types.BaseEvent;
export type IdentifyEvent = amplitude.Types.IdentifyEvent;
export type GroupEvent = amplitude.Types.GroupIdentifyEvent;
export type Event = amplitude.Types.Event;
export type EventOptions = amplitude.Types.EventOptions;
export type Result = amplitude.Types.Result;
